module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M18 2.7l2.2 3.1h-4.4zM7.3 12l3.2-2.2v4.4zM18 21.9l-2.2-3.2h4.4zM28.7 12l-3.2 2.2V9.8z","fill":"#fff"}}),_c('path',{attrs:{"d":"M9.5 11.5h17.1v1H9.5z","fill":"#fff"}}),_c('path',{attrs:{"d":"M17.5 3.7h1v17.1h-1z","fill":"#fff"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-icons/tool_move_size.svg
// module id = 726
// module chunks = 2